export const REQUEST_SESSION_TYPE = "SESSION_TYPE"
export const REQUEST_EVENTS_TYPE = "EVENTS_TYPE"
export const REQUEST_GAP_TYPE = "GAP_TYPE"
export const REQUEST_CHART_EVENT_TYPE = "CHART_EVENT_TYPE"
export const REQUEST_CHART_SESSION_TYPE = "CHART_SESSION_TYPE"